import React from 'react';
import { CheckSquare, Square } from 'lucide-react';

interface ExportListProps {
  workspaces: any[];
  selectedIds: Set<string>;
  handleToggleWorkspace: (id: string) => void;
}

export function ExportList({ workspaces, selectedIds, handleToggleWorkspace }: ExportListProps) {
  if (workspaces.length === 0) {
    return (
      <div className="text-center py-4 text-sm text-slate-500 dark:text-slate-400">
        No workspaces found.
      </div>
    );
  }

  return (
    <>
      {workspaces.map((w) => (
        <button
          key={w.id}
          onClick={() => handleToggleWorkspace(w.id)}
          className="w-full flex items-center justify-between p-3 rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800/80 transition-colors text-left cursor-pointer"
        >
          <div className="flex flex-col">
            <span className="text-sm font-medium text-slate-800 dark:text-slate-200 truncate pr-4">{w.name}</span>
            <span className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
              {w.mode === 'tailor' ? 'Resume Analyze' : 'Job Search'}
            </span>
          </div>
          <div className="shrink-0 text-emerald-600 dark:text-emerald-500">
            {selectedIds.has(w.id) ? (
              <CheckSquare className="w-5 h-5" />
            ) : (
              <Square className="w-5 h-5 text-slate-300 dark:text-slate-600" />
            )}
          </div>
        </button>
      ))}
    </>
  );
}
